import React from 'react';
import { MultiWebClientMerchantModel } from '@/User/domain';
import edificioPng from '../../assets/edificio.png';
import { DROPDOWN_STYLES } from '../constants/styles';

interface MerchantItemProps {
  merchant: MultiWebClientMerchantModel;
  isHovered: boolean;
  isFirst: boolean;
  isLast: boolean;
  hasSubItems: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
}

/**
 * Componente atómico para mostrar un item de comercio principal en la lista.
 * Incluye icono, nombre, CIF y código del comercio.
 * 
 * @param merchant - Datos del comercio a mostrar
 * @param isHovered - Indica si el item está siendo hovereado
 * @param isFirst - Indica si es el primer item de la lista
 * @param isLast - Indica si es el último item de la lista
 * @param hasSubItems - Indica si el comercio tiene sub-items
 * @param onMouseEnter - Función para manejar el hover
 * @param onMouseLeave - Función para manejar cuando sale del hover
 * @param onClick - Función para manejar el clic
 */
export const MerchantItem: React.FC<MerchantItemProps> = ({
  merchant,
  isHovered,
  isFirst,
  isLast,
  hasSubItems,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        ...DROPDOWN_STYLES.merchantItemBase,
        background: isHovered ? '#F1F5F9' : 'transparent',
        borderTop: !isFirst ? '1.5px solid #e0e0e0' : 'none',
        borderBottom: isLast && !hasSubItems ? 'none' : '1.5px solid #e0e0e0',
      }}
    >
      <span style={DROPDOWN_STYLES.merchantItemIcon}>
        <img src={edificioPng} alt="edificio" width={22} height={22} />
      </span>
      <span style={DROPDOWN_STYLES.merchantItemContent}>
        <span style={DROPDOWN_STYLES.merchantItemName}>
          {merchant.name}
        </span>
        <span style={DROPDOWN_STYLES.merchantItemDetails}>
          {merchant.cif} - {merchant.code}
        </span>
      </span>
    </div>
  );
};
